import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { AnimatedSection } from '@/components/shared/AnimatedSection'
import { ROOMS_ROUTE, CONTACT } from '@/lib/constants'

// Real site section 9 (final-cta):
//   background: white (#FFFFFF)
//   heading: "NUEVA VALLADOLID es tu Hotel perfecto en Comayagua"
//   layout: centered, contained max-w-7xl
//   CTA button: pill, filled #0F2966 bg, white text, 200×50px
//   hover: bg #F3EADB, text #0F2966
//   Matches real site's "instagram-cta" + "final-cta" combined into one section

export function CtaSection() {
  const { i18n } = useTranslation()
  const es = i18n.language.startsWith('es')

  return (
    <section
      className="py-24"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto max-w-3xl px-10 text-center">
        <AnimatedSection>
          {/* Eyebrow / subtext above main heading */}
          <p
            className="mb-4 text-sm font-bold uppercase tracking-widest"
            style={{ color: '#61988E' }}
          >
            {es ? 'Comayagua, Honduras' : 'Comayagua, Honduras'}
          </p>

          {/* Main heading — matches real site: "NUEVA VALLADOLID es tu Hotel perfecto en Comayagua" */}
          <h2
            className="text-3xl font-bold uppercase tracking-wide md:text-4xl"
            style={{ color: '#0F2966' }}
          >
            {es
              ? 'NUEVA VALLADOLID es tu Hotel perfecto en Comayagua'
              : 'NUEVA VALLADOLID is your perfect Hotel in Comayagua'}
          </h2>

          {/* Supporting text */}
          <p
            className="mt-4 text-base leading-relaxed"
            style={{ color: '#666666' }}
          >
            {es
              ? 'Un refugio corporativo en el corazón histórico de Comayagua. Habitaciones silenciosas, áreas de trabajo privadas y servicio personalizado.'
              : 'A corporate refuge in the historic heart of Comayagua. Quiet rooms, private work areas, and personalized service.'}
          </p>

          {/* CTA buttons — pill style, 200×50px primary, matches real site */}
          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            {/* Primary: filled navy pill → booking page */}
            <Link
              to={ROOMS_ROUTE}
              className="group inline-flex items-center justify-center font-bold uppercase tracking-widest text-white transition-colors"
              style={{
                backgroundColor: '#0F2966',
                borderRadius: '100px',
                width: '200px',
                height: '50px',
                fontSize: '14px',
                border: '1px solid #0F2966',
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLAnchorElement
                el.style.backgroundColor = '#F3EADB'
                el.style.color = '#0F2966'
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLAnchorElement
                el.style.backgroundColor = '#0F2966'
                el.style.color = '#FFFFFF'
              }}
            >
              {es ? 'Reservar Ahora' : 'Book Now'}
            </Link>

            {/* Secondary: outline pill → phone */}
            <a
              href={`tel:${CONTACT.phone.replace(/\s/g, '')}`}
              className="inline-flex items-center justify-center font-bold uppercase tracking-widest transition-colors"
              style={{
                backgroundColor: 'transparent',
                border: '1px solid #0F2966',
                borderRadius: '100px',
                width: '200px',
                height: '50px',
                fontSize: '14px',
                color: '#0F2966',
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLAnchorElement
                el.style.backgroundColor = '#F3EADB'
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLAnchorElement
                el.style.backgroundColor = 'transparent'
              }}
            >
              {CONTACT.phone}
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  )
}
